import { render } from "./Contact.vue?vue&type=template&id=c71c6348&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=c71c6348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c71c6348"

export default script